var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4814 17.25C15.084 17.25 14.7627 17.572 14.7627 17.9688V20.8438H1.8252V2.15625H9.0127V7.1875C9.0127 7.58425 9.33398 7.90625 9.73145 7.90625H14.7627V10.7812C14.7627 11.178 15.084 11.5 15.4814 11.5C15.8789 11.5 16.2002 11.178 16.2002 10.7812V7.25722C16.2024 7.2335 16.2146 7.21194 16.2146 7.1875C16.2146 6.94528 16.0953 6.73109 15.912 6.601L10.2396 0.929344C10.1778 0.86825 10.1052 0.823688 10.0297 0.789188C10.0074 0.778406 9.98445 0.772656 9.96001 0.76475C9.90107 0.744625 9.8407 0.732406 9.77816 0.728813C9.76235 0.727375 9.74726 0.71875 9.73145 0.71875H1.10645C0.708977 0.71875 0.387695 1.04075 0.387695 1.4375V21.5625C0.387695 21.9592 0.708977 22.2812 1.10645 22.2812H15.4814C15.8789 22.2812 16.2002 21.9592 16.2002 21.5625V17.9688C16.2002 17.572 15.8789 17.25 15.4814 17.25ZM10.4502 6.46875V3.17256L13.7464 6.46875H10.4502Z",
    fill: "#219EBC",
    stroke: "black",
    strokeWidth: 0.008
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8815 11.009C18.6091 10.7187 18.1556 10.7043 17.8652 10.9753L10.6748 17.7028L7.34775 14.5891C7.05738 14.3174 6.60313 14.3325 6.33144 14.6229C6.06047 14.9126 6.07556 15.3675 6.36522 15.6385L10.1839 19.2114C10.3219 19.3408 10.4988 19.4055 10.6756 19.4055C10.8524 19.4055 11.0285 19.3408 11.1672 19.2114L18.8492 12.0239C19.1381 11.7537 19.1525 11.2987 18.8815 11.009Z",
    fill: "#219EBC",
    stroke: "black",
    strokeWidth: 0.008
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.c7a8de43735a5c226e7ad16bc5ae3a1e.svg";
export { ForwardRef as ReactComponent };